import { defSetter } from "./setter.js";
const setInUnsafe = (state, path, val) => defSetter(path)(state, val);
function setIn(state, path, val) {
  return defSetter(path)(state, val);
}
export {
  setIn,
  setInUnsafe
};
